/**
 * @file 标签页
 * @author wangzhuang
 */

import {rcAjax} from '../util';
import {GET_CMSAPI_TAGARTICLEDATA} from './ActionTypes';

export function fetchCmsapiTagArticleData(dispatch, tagIdObj, isMore) {
    return rcAjax('GET', '/cmsapi/tagArticleData', tagIdObj, {}, data => {
        dispatch({type: GET_CMSAPI_TAGARTICLEDATA, data: data.data, isMore: isMore});
    });
}




// WEBPACK FOOTER //
// ./src/actions/markAction.js